import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import AxiosOICStat from '../AxiosOICStat';

export const fetchIndicators = createAsyncThunk(
    'indicators/fetchIndicators',
    async () => {
        const response = await AxiosOICStat.get(`/indicators/indicator-details/all`);
        let indicators = {};
        response.data.forEach(indicator => {
            indicators[indicator.ind_code] = indicator;
        });
        return indicators;
    }
);

export const indicatorsSlice = createSlice({
    name: 'indicators',
    initialState: {
        status: 'idle',
        value: [],
    },
    reducers: {
        setIndicators(state, action) {
            state.value = action.payload;
        },
        setIndicator(state, action) {
            state.value[action.payload.ind_code] = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchIndicators.pending, (state) => {
            state.status = 'loading';
        }).addCase(fetchIndicators.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.value = action.payload;
        }).addCase(fetchIndicators.rejected, (state) => {
            state.status = 'failed';
        });
    },
});

export const { setIndicator } = indicatorsSlice.actions;
export const { setIndicators } = indicatorsSlice.actions;

export default indicatorsSlice.reducer;
